'use client';

import { useEffect } from 'react';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { useAppNotification } from '../../notifications/NotificationContextProvider';
import { usePathname } from 'next/navigation';
import { useClientUserInfo } from '../userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { useUserAccessControl } from '../utils/userAccess';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { useFeatureFlag } from '../../statsig/sdk/provider';

export const PepTradeStatusNotificationObserver = () => {
  const { setAppNotification, closeNotificationById } = useAppNotification();

  const { t, language } = useClientTranslation();

  const userData = useClientUserInfo();

  const { isPepFailed } = useUserAccessControl();

  const { pepStatus, tradingActive, active } = userData;

  const pathname = usePathname();

  const feature_isUkLicensed = useFeatureFlag('feature_isUkLicensed');

  const getPepMessages = () => {
    if (pepStatus === 'NONE' && !tradingActive && active) {
      return {
        title: t('error_pep_none_user_active_trade_inactive_title'),
        subtitle: t('error_pep_none_user_active_trade_inactive_message'),
      };
    }

    if (pepStatus === 'FAILED' && !tradingActive && active) {
      return {
        title: t('error_pep_failed_user_active_trade_inactive_title'),
        subtitle: t('error_pep_failed_user_active_trade_inactive_message'),
      };
    }

    if (pepStatus === 'FAILED' && !tradingActive && !active) {
      return {
        title: t('error_pep_failed_user_inactive_trade_inactive_title'),
        subtitle: t('error_pep_failed_user_inactive_trade_inactive_message'),
      };
    }

    if (pepStatus === 'SUCCESS' && !tradingActive && active) {
      return {
        title: t('error_pep_success_user_active_trade_inactive_title'),
        subtitle: t('error_pep_success_user_active_trade_inactive_message'),
      };
    }

    return null;
  };

  const messages = getPepMessages();

  useEffect(() => {
    if (!pathname) return;

    const isOnRoot = pathname === NEXT_ROUTES.ROOT;

    const isOnOnboarding = pathname.includes(NEXT_ROUTES.ONBOARDING);

    const isOnTaxDetails = pathname.includes(NEXT_ROUTES.TAX_DETAILS);

    const isOnClientCategorization = pathname.includes(
      NEXT_ROUTES.CLIENT_CATEGORIZATION,
    );

    if (
      !isOnRoot &&
      !isOnOnboarding &&
      !isOnTaxDetails &&
      !isOnClientCategorization &&
      !feature_isUkLicensed &&
      messages &&
      isPepFailed
    ) {
      setAppNotification({
        ...messages,
        id: 'pep-trade-status',
        withClose: true,
        type: 'global',
        visual: 'warning',
        customDuration: 'infinite',
      });
    } else {
      closeNotificationById('pep-trade-status');
    }
  }, [isPepFailed, pathname, language, feature_isUkLicensed]);

  return null;
};
